/**
 * Scrolls the viewport to the first error field in a form by finding the associated input element
 * and smoothly scrolling it into view.
 *
 * @param {Object} errors - An object containing error information, where keys are field names
 * and values are the associated error messages.
 *
 */
const scrollToFirstErrorField = (errors = []) => {
  if (errors && Object.keys(errors).length > 0) {
    const firstErrorField = Object.keys(errors)[0];
    const errorElement = document.querySelector(`[name="${firstErrorField}"]`);

    if (errorElement) {
      errorElement.scrollIntoView({ behavior: 'smooth', block: 'center' });
    }
  }
};

export default scrollToFirstErrorField;
